<template>
    <div>
        <div class="card card-default">
            <div class="card-header">Add Administrator</div>

            <div class="card-body">

                <div class="alert alert-success" v-if="form.successful">
                    The admin has been added!
                </div>

                <form role="form">

                    <div class="alert alert-warning font-08em">
                        The user needs to have access to the system to be added as an administrator. If doesn't you can
                        invite the user to be part to your team.
                        <a :href="`/settings/teams/${user.current_team_id}#/membership`">
                            Click here to invite.
                        </a>
                    </div>

                    <div class="form-group row">
                        <label class="col-md-4 col-form-label text-md-right">E-Mail Address</label>

                        <div class="col-md-6">
                            <input type="email" class="form-control" name="email" v-model="form.email"
                                   :class="{'is-invalid': form.errors.has('email')}">

                            <span class="invalid-feedback" v-show="form.errors.has('email')">
                                {{ form.errors.get('email') }}
                            </span>
                        </div>
                    </div>

                    <div class="form-group row mb-0">
                        <div class="offset-md-4 col-md-6">
                            <button type="submit" class="btn btn-primary"
                                    @click.prevent="send"
                                    :disabled="form.busy">

                                <span v-if="form.busy">
                                    <i class="fa fa-btn fa-spinner fa-spin"></i> Adding...
                                </span>

                                <span v-else>
                                    Add Administrator
                                </span>
                            </button>
                        </div>
                    </div>
                </form>

            </div>
        </div>

        <div class="card card-default">
            <div class="card-header">
                Admins ({{ developers.length }})
            </div>

            <div class="table-responsive">
                <table class="table table-valign-middle mb-0">
                    <thead>
                    <tr>
                        <th class="th-fit"></th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>&nbsp;</th>
                    </tr>
                    </thead>

                    <tbody>
                    <tr v-for="developer in developers">
                        <td>
                            <img :src="developer.user.photo_url" class="spark-profile-photo">
                        </td>

                        <td>
                            <span v-if="developer.user.id === user.id">
                                You
                            </span>

                            <span v-else>
                                {{ developer.user.name }}
                            </span>
                        </td>

                        <td>{{ developer.user.email }}</td>

                        <td class="td-fit">
                            <button class="btn btn-outline-danger" @click="approveDeveloperDelete(developer)"
                                    v-if="developer.user.id !== user.id">
                                <i class="fa fa-trash"></i>
                            </button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="modal" id="modal-delete-developer" tabindex="-1" role="dialog">
            <div class="modal-dialog" v-if="deleting">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Remove Admin ({{ deleting.user.name }})
                        </h5>
                    </div>

                    <div class="modal-body">
                        Are you sure you want to remove this admin?
                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">
                            No, Go Back
                        </button>

                        <button type="button" class="btn btn-danger" @click="deleteDeveloper"
                                :disabled="deleteForm.busy">
                            Yes, Remove
                        </button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        data: () => ({
            form      : new SparkForm({email: ''}),
            developers: [],
            deleting  : null,
            deleteForm: new SparkForm({})
        }),

        created() {
            this.load();
        },

        computed: {
            user() {
                return this.$root.user;
            }
        },

        methods: {
            load() {
                const uri = laroute.route('spark.kiosk.developer.index');
                axios.get(uri)
                     .then((res) => {
                         this.developers = res.data.data;
                     });
            },

            send() {
                const uri = laroute.route('spark.kiosk.developer.store');
                window.Spark.post(uri, this.form)
                      .then((res) => {
                          this.form.email = '';

                          this.developers.push(res.data);
                      });
            },

            approveDeveloperDelete(developer) {
                this.deleting = developer;

                $('#modal-delete-developer').modal('show');
            },


            deleteDeveloper() {
                window.Spark.delete(`/spark/kiosk/developer/${this.deleting.id}`, this.deleteForm)
                      .then(() => {
                          this.load();

                          $('#modal-delete-developer').modal('hide');
                      });
            },
        }
    }
</script>

<style scoped>

</style>
